import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";

import "./About.css";

const About = () => {
  const ref = useRef(null);
  React.useEffect(() => {
    import("@lottiefiles/lottie-player");
  });

  return (
    <div className="about">
      <Container data-aos="fade-right" className="about-icons">
        <Row>
          <Col xs={12} md={3}>
            <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets4.lottiefiles.com/packages/lf20_kp0JLL.json"
              style={{ width: "200px", height: "200px"  }}
            ></lottie-player>{" "}
            <br />
            <h2>Fast</h2>
            <p>
              Fast load times and lag free interaction, my highest priority.
            </p>
          </Col>
          <Col xs={12} md={3}>
            <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets7.lottiefiles.com/packages/lf20_wqd1jwoz.json"
              style={{ width: "200px", height: "200px" }}
            ></lottie-player>{" "}
            <br />
            <h2>Responsive</h2>
            <p>My layouts will work on any device, big or small.</p>
          </Col>
          <Col xs={12} md={3}>
            <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets5.lottiefiles.com/packages/lf20_htve1llz.json"
              style={{ width: "200px", height: "200px" }}
            ></lottie-player>{" "}
            <br />
            <h2>Intuitive</h2>
            <p>Strong preference for easy to use, intuitive UX/UI.</p>
          </Col>{" "}
          <Col xs={12} md={3}>
            <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets6.lottiefiles.com/packages/lf20_uhfhrlxf.json"
              style={{ width: "200px", height: "200px" }}
            ></lottie-player>{" "}
            <br />
            <h2>Dynamic</h2>
            <p>
              Websites don't have to be static, I love making pages come to
              life.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default About;
